var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2449)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#AA701A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 2H14.0001C11.791 2 10.0001 3.79086 10.0001 6V24C10.0001 26.2091 11.791 28 14.0001 28H32.0001C34.2093 28 36.0001 26.2091 36.0001 24V6C36.0001 3.79086 34.2093 2 32.0001 2Z",
    fill: "#CC962C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0056 11.99H16.2806V10.82C16.7506 10.82 17.1256 10.78 17.4056 10.7C17.6956 10.62 17.9256 10.49 18.0956 10.31C18.2656 10.12 18.4156 9.85 18.5456 9.5H19.6556V20H18.0056V11.99ZM21.7014 18.41H23.2914V20H21.7014V18.41ZM26.8686 20.15C26.0586 20.15 25.4436 19.925 25.0236 19.475C24.6136 19.025 24.4086 18.38 24.4086 17.54V16.685H25.9686V17.615C25.9686 18.305 26.2536 18.65 26.8236 18.65C27.1036 18.65 27.3136 18.565 27.4536 18.395C27.6036 18.215 27.6786 17.905 27.6786 17.465V16.61C27.6786 16.13 27.5936 15.79 27.4236 15.59C27.2536 15.38 26.9786 15.275 26.5986 15.275H26.0436V13.775H26.6436C26.9736 13.775 27.2186 13.69 27.3786 13.52C27.5486 13.35 27.6336 13.065 27.6336 12.665V11.9C27.6336 11.54 27.5586 11.275 27.4086 11.105C27.2586 10.935 27.0586 10.85 26.8086 10.85C26.2786 10.85 26.0136 11.175 26.0136 11.825V12.515H24.4536V11.96C24.4536 11.12 24.6586 10.475 25.0686 10.025C25.4886 9.575 26.0886 9.35 26.8686 9.35C27.6586 9.35 28.2586 9.575 28.6686 10.025C29.0786 10.465 29.2836 11.105 29.2836 11.945V12.32C29.2836 12.89 29.1886 13.35 28.9986 13.7C28.8086 14.04 28.5136 14.285 28.1136 14.435V14.465C28.5436 14.625 28.8536 14.885 29.0436 15.245C29.2336 15.605 29.3286 16.065 29.3286 16.625V17.555C29.3286 18.395 29.1186 19.04 28.6986 19.49C28.2886 19.93 27.6786 20.15 26.8686 20.15Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2449",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2449"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2449",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/1-3.562db73592a1b249a17fbe8d227d9927.svg";
export { ForwardRef as ReactComponent };